import type { ReactNode } from 'react'

import { usePermissions } from '@/hooks/usePermissions'

type RenderPropChildren = (props: { allowed: boolean }) => ReactNode

export type PermissionGuardProps = {
  permission?: string
  anyPermission?: string[]
  children: ReactNode | RenderPropChildren
  fallback?: ReactNode
}

export const PermissionGuard = ({
  permission,
  anyPermission,
  children,
  fallback = null,
}: PermissionGuardProps) => {
  const permissions = usePermissions()

  const allowed =
    (!permission || permissions.includes(permission)) &&
    (!anyPermission?.length ||
      anyPermission.some((p) => permissions.includes(p)))

  if (typeof children === 'function') {
    return <>{children({ allowed })}</>
  }

  return <>{allowed ? children : fallback}</>
}
